import { debounce } from './utils';

export const ViewPort = {
    'xs': 1,
    'sm': 2,
    'md': 3,
    'lg': 4,
    'xl': 5,

    1: 'xs',
    2: 'sm',
    3: 'md',
    4: 'lg',
    5: 'xl',

    _getMediaElement() {
        this._matcher = this._matcher || (function() {
            const matcher = document.createElement('div');
            matcher.className = 'match-media';
            document.body.appendChild(matcher);
            return matcher;
        })();
        return this._matcher;
    },

    getCurrent() {
        const matcher = this._getMediaElement();
        const matcherComputed = window.getComputedStyle(matcher).getPropertyValue('z-index');
        if (matcherComputed === 'auto'){
            return 5;//eslint-disable-line no-magic-numbers
        }
        return parseInt(matcherComputed, 10);
    }
};

/**
 * @function matchMedia
 * @param {number} viewPort
 * @description Check if the current screen size matches a given ViewPort
 */
export function matchMedia(...args) {
    if(args.length === 0) {
        throw new Error('No arguments provided');
    } else if(args[0] == null) {
        throw new Error('Arguments can\'t be undefined or null');
    }

    return  {
        get matches() {
            return args.some((port) => ViewPort.getCurrent() === port);
        },
        get media() {
            return args.map(port => ViewPort[port]);
        },
        get currentPort() {
            return ViewPort.getCurrent();
        },
        addListener(fn) {
            fn._wrapper = debounce(() => this.matches && fn(this), 200);
            window.addEventListener('resize', fn._wrapper);
        },
        removeListener(fn) {
            window.removeEventListener('resize', fn._wrapper);
        }
    };
}
